import { render } from "./InterimPayements.vue?vue&type=template&id=5873af47"
import script from "./InterimPayements.vue?vue&type=script&lang=js"
export * from "./InterimPayements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__